import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Axios from "axios";
import imageCompression from "browser-image-compression";
import EditViewStockPage from "./EditModal";

const EditViewStockPageWrapper = () => {
  const { itemCode } = useParams();
  const navigate = useNavigate();

  const [selectedStock, setSelectedStock] = useState(null);
  const [product, setProduct] = useState(null);
  const [formData, setFormData] = useState({
    photo1: null,
    photo2: null,
    billUpload: null,
    purchaseCost: "",
    purchaseDate: "",
    warranty: "",
    warrantyExpiryDate: "",
    services: [],
  });

  const [loading, setLoading] = useState(true);
  const [loadings, setLoadings] = useState(false);
  const [uploading, setUploading] = useState(false);

  const fileInput1 = useRef(null);
  const fileInput2 = useRef(null);
  const fileInput3 = useRef(null);

console.log(selectedStock," selectedStock");
  useEffect(() => {
   const fetchData = async () => {

  try {
    const decodedItemCode = decodeURIComponent(itemCode);

    const response = await Axios.post("/api/products/itemcode/details", {
      itemCode: decodedItemCode,
    });
    // Assuming your API returns both stock and product like:
    // { stock: {...}, product: {...} }
    const { stock, product } = response.data;

    if (!stock || !product) {
      console.warn("Stock or product data is missing from response");
      return;
    }

    setSelectedStock(stock);
    setFormData(stock); // if your formData shape matches stock
    setProduct(product);
  } catch (error) {
    console.error("Error fetching item code details:", error);
  } finally {
    setLoading(false);
  }
};

    fetchData();
  }, [itemCode]);

  const handleFileChange = async (e, fieldName, index = null, isService = false) => {
    const file = e.target.files[0];
    if (!file) return;

    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const uploadFormData = new FormData();
      uploadFormData.append("image", compressedFile);

      setUploading(true);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await Axios.post("/api/upload", uploadFormData, config);

      if (isService && index !== null) {
        setFormData((prev) => {
          const updatedServices = [...prev.services];
          updatedServices[index] = {
            ...updatedServices[index],
            photo: data,
          };
          return { ...prev, services: updatedServices };
        });
      } else {
        setFormData((prev) => ({ ...prev, [fieldName]: data }));
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setUploading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoadings(true);
    if (!product?._id || !selectedStock?.itemCode) {
      console.error("Product ID or Stock Item Code is missing");
      return;
    }

    try {
      await Axios.put(
        `/api/products/${product._id}/stock/${selectedStock.itemCode}`,
        {
          photo1: formData.photo1,
          photo2: formData.photo2,
          billUpload: formData.billUpload,
          purchaseCost: formData.purchaseCost,
          purchaseDate: formData.purchaseDate,
          warranty: formData.warranty,
          warrantyExpiryDate: formData.warrantyExpiryDate,
          services: formData.services || [],
        }
      );
      alert("Stock item updated successfully!");
      navigate("/stocks"); // or back to previous page
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setLoadings(false);
    }
  };

  return selectedStock ? (
    <EditViewStockPage
      handleUpdate={handleUpdate}
      handleFileChange={handleFileChange}
      formData={formData}
      setFormData={setFormData}
      selectedStock={selectedStock}
      loading={loading}
      loadings={loadings}
      fileInput1={fileInput1}
      fileInput2={fileInput2}
      fileInput3={fileInput3}
    />
  ) : (
    <p>Loading...</p>
  );
};

export default EditViewStockPageWrapper;
